<template>

<div v-if="site.id =='GA'">
    <div class="contact-phone-gildemeister ga" :class="{ 'contact-phone--inline': inline }">
    <button class="btn-numeber ml-3 ml-lg-0 d-lg-flex" v-if="phone">
     <p class="pr-lg-2">Fonoagendamiento:</p>  <!---<a :href="`tel:${phone}`">{{ phone }}</a>--><a :href="`tel:600 5700 006`">600 5700 007</a>
    </button>
    <span v-if="phone && cellphone && inline" class="mx-2">/</span>
    <button class="btn-numeber  d-lg-flex" v-if="cellphone">
     <p class="pr-lg-2">Desde Celulares:</p>  <!---<a :href="`tel:${cellphone}`">{{ cellphone }}</a>--><a :href="`tel:600 5700 006`">600 5700 007</a>
    </button>
  </div> 
</div>
<div v-else-if="site.id =='FZ'">
    <div class="contact-phone-gildemeister" :class="{ 'contact-phone--inline': inline }">
    <button class="btn-numeber" v-if="phone">
      Fonoagendamiento: <!---<a :href="`tel:${phone}`">{{ phone }}</a>--><a :href="`tel:600 5700 006`">600 5700 006</a>
    </button>
    <span v-if="phone && cellphone && inline" class="mx-2">/</span>
    <button class="btn-numeber" v-if="cellphone">
      Desde Celulares: <!---<a :href="`tel:${cellphone}`">{{ cellphone }}</a>--><a :href="`tel:600 5700 006`">600 5700 006</a>
    </button>  
  </div>   
</div>
<div v-else-if="site.id =='HYU'">
  <div class="contact-phone" :class="{ 'contact-phone--inline': inline }">
    <p v-if="phone">
      Fonoagendamiento: <!---<a :href="`tel:${phone}`">{{ phone }}</a>--><a :href="`tel:600 570 0007`">600 570 0007 </a>
    </p>
    <span v-if="phone && cellphone && inline" class="mx-2">/</span>
    <p v-if="cellphone">
      Desde Celulares: <!---<a :href="`tel:${cellphone}`">{{ cellphone }}</a>--><a :href="`tel:227970224`">227970224</a>
    </p>
  </div>
</div>
<div v-else>
  <div class="contact-phone" :class="{ 'contact-phone--inline': inline }">
    <p v-if="phone">
      Fonoagendamiento: <!---<a :href="`tel:${phone}`">{{ phone }}</a>--><a :href="`tel:600 570 0006`">600 570 0006</a>
    </p>
    <span v-if="phone && cellphone && inline" class="mx-2">/</span>
    <p v-if="cellphone">
      Desde Celulares: <!---<a :href="`tel:${cellphone}`">{{ cellphone }}</a>--><a :href="`tel:227970227`">227970227</a>
    </p>
  </div>
</div>

  
</template>

<script>
export default {
  name: 'ContactPhones',
  
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phone: process.env.VUE_APP_BRAND_PHONE,
      cellphone: process.env.VUE_APP_BRAND_CELL,
      url: process.env.VUE_APP_BRAND_SITE_URL,
       site: {
        id: process.env.VUE_APP_BRAND_ID || '',
        label: process.env.VUE_APP_BRAND_SITE_LABEL || '',
        url: process.env.VUE_APP_BRAND_SITE_URL || '',

      }
    };
  },
};
</script>
<style lang="scss">
.contact-phone-gildemeister {
 margin-bottom: 25px;
    line-height: 18px;
  button {
  border: 0;
    display: block;
    background: none;
    font-size: 13px;
    color: grey;
    padding-left: 0px;
    padding-top: 0px;
    padding-bottom: 2px;
     a {
       color: rgb(6, 61, 121);
      text-decoration: revert;
      font-weight: 600;
}
}
}
a.auth__external_gilde.site-external {
    background: #00a2e34d;
    left: 0;
    color: #0070ba;
    font-weight: 700;
}

@media (max-width: 500px) {
     
.contact-phone-gildemeister button.btn-numeber {
    background: #00a2e3;
    border: 0px;
    border-radius: 6px;
    color: white;
    padding: 10px;
    margin-bottom: 11px;
    width: 100%;
    margin-right: 15px;
    font-weight: 800;
}

.contact-phone-gildemeister {
    position: absolute;
    top: 30rem;
    display: flex;
    a {
    color: #ffffff;
    font-weight: 600;
    text-decoration: underline;
}
}
.login__actions {
   
    margin-bottom: 40px;
}
}
 
</style>

